// Business details shown in the footer and on the info pages.
export const COMPANY = {
  legalName: "Shubhkrish Ventures Private Limited",
  cin: "U10799HR2026PTC148457",
  address: ["3rd Floor, 346A, Block B, Sushant Lok Phase 1,", "Gurgaon, Haryana — 122001, India"],
  email: "listen@dnabars.com",
  phone: "",
  hours: "Mon – Sat, 10am – 6pm IST",
};

// Google Form for corporate / office pantry enquiries. Until it is set, the
// footer link falls back to the contact page.
export const CORPORATE_PANTRY_FORM_URL = "";

// Mirrors LOYALTY in server/src/utils/pricing.js — the server is the source of truth.
export const LOYALTY = {
  earnRate: 0.05,
  pointValue: 1,
  maxRedeemShare: 0.2,
};

export const maxRedeemablePoints = (balance, subtotal) =>
  Math.max(0, Math.min(balance, Math.floor((subtotal * LOYALTY.maxRedeemShare) / LOYALTY.pointValue)));
